import React, { Component } from "react";
import { httpPut } from "../../../Util/http";
import { connect } from "react-redux";
import Waves from "node-waves";
import Radium from "radium";
import Modal from "../../../Common/modal";
import { semanticColors } from "../../../Globals/styles";
import DatepickerOnWeeks from "../../../Common/datepickerOnWeeks";
import Datepicker from "../../../Common/datepicker";
import EmployeeOverview from "./employeeOverview";
import DailyReportContainer from "./dailyReportContainer";
import Employees from "./Employees";
import StaticDailyReport from "./staticDailyReport";
import EmailModal from "./emailModal";
import ConfirmationModal from "../../../Common/confirmationModal";
import PageSpinner from "../../../Common/pageSpinner";
import DailyReportSwitch from "./dailyReportSwitch";
import { Scrollbars } from "react-custom-scrollbars";
import PicFSUpload from "../../../Common/picFSUpload";
import { dateToString } from "../../../Util/dateTime";
/*https://github.com/xiaolin/react-image-gallery*/
import ImageGallery from "../../../Common/ImageGallery";
import Imag from "../Images/index3";

import {
  setDate,
  attemptGetDailyReport,
  attemptGetDailyReportInit,
  attemptCreateDailyReport,
  setEmployeeIsDragging,
  rmEmployeeFromWorkplace,
  getEmployeeSuggestions,
  attemptAddEmployee,
  setIsShowingTimeRegistration,
  attemptSaveDayReport,
  dailyReportToggleEdit,
  dailyReportToggleEditSignature,
  attemptDeleteDailyReport,
  getEmailSuggestions,
  attemptSendEmails,
  setShowEmailConfirmation,
} from "./actions";

import auth from "../../../Login/authService";

class DailyReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowingDeleteModal: false,
      isShowingEmailModal: false,
      hide: true,
      document: null,
      hideChangeDate: true,
    };
  }
  componentWillMount = () => {
    if (this.props.params.dailyreportId) {
      this.props.dispatch(
        attemptGetDailyReport(this.props.params.dailyreportId)
      );
    } else {
      this.props.dispatch(
        attemptGetDailyReportInit(null, this.props.params.workplaceId)
      );
    }
  };
  componentWillReceiveProps = (nextProps) => {
    // if ((!nextProps.understood || !nextProps.safety) && auth.getProfile().role === 'Formand') {
    //   alert('For at tilgå dagrapporter skal du først gennemgå arbejdsmiljø fanen')
    //   this.props.dispatch(routeActions.push('/afdeling/' + this.props.params.departmentId + '/arbejdssted/' + this.props.params.workplaceId + '/arbejdsmiljo'))
    // }
  };
  changeDate = (newDate) => {
    this.props.dispatch(
      attemptGetDailyReportInit(newDate, this.props.params.workplaceId)
    );
    this.props.dispatch(setDate(newDate));
  };
  componentWillUnmount = () => {
    this.props.dispatch(setDate(new Date()));
  };
  componentDidMount = () => {
    Waves.attach(".waves-btn", ["waves-button"]);
    Waves.attach(".waves-icon", ["waves-circle"]);
  };
  toggleIsShowingDeleteModal = () => {
    this.setState({
      isShowingDeleteModal: !this.state.isShowingDeleteModal,
    });
  };
  toggleIsShowingEmailModal = () => {
    this.setState({
      isShowingEmailModal: !this.state.isShowingEmailModal,
    });
    this.props.dispatch(setShowEmailConfirmation(false));
  };
  componentDidUpdate = () => {
    Waves.attach(".waves-btn", ["waves-button"]);
    Waves.attach(".waves-icon", ["waves-circle"]);
  };
  onCancel = () => {
    const { dispatch, dailyReportIsEdit, params, currentDailyReportId } =
      this.props;
    if (dailyReportIsEdit) {
      dispatch(attemptGetDailyReport(currentDailyReportId));
    } else {
      dispatch(attemptGetDailyReportInit(null, params.workplaceId));
    }
  };
  getTotalActivityHours = () => {
    const { activities } = this.props;
    let result = 0;
    activities.forEach((a) => {
      result += a.hours;
    });
    return result;
  };
  openPdf = (pdfUrl, base64) => {
    if (base64) {
      this.setState({
        hide: false,
        document: { base64: "data:application/pdf;base64, " + pdfUrl },
      });
    } else {
      this.setState({
        hide: false,
        document: { url: pdfUrl },
      });
    }
  };
  delay = (t, returnValue) => {
    return new Promise(function (resolve) {
      setTimeout(() => resolve(returnValue), t);
    });
  };
  render() {
    const {
      date,
      employees,
      dispatch,
      employeeIsDragging,
      employeeSuggestions,
      params,
      isShowingTimeRegistration,
      isSavingDailyReport,
      isEditMode,
      signature,
      isEditSignature,
      approved,
      emailSuggestions,
      isLoading,
      listOfDailyReports,
      currentDailyReportId,
      isSending,
      userAcks,
    } = this.props;
    let token = auth.getToken();
    let dateString = JSON.parse(JSON.stringify(date));
    let _url =
      process.env.REACT_APP_webApiEndPoint +
      "api/dailyreport/print?workplaceId=" +
      params.workplaceId +
      "&date=" +
      dateString +
      "&token=" +
      token;
    //add no to the print string
    if (currentDailyReportId != null) {
      let currentDailyReportIdSplit = currentDailyReportId.split("&");
      let no =
        currentDailyReportIdSplit.length === 3
          ? currentDailyReportIdSplit[2]
          : "";
      _url += "&no=" + no;
    }

    return (
      <div className="row" style={styles.innerContainer}>
        <Modal
          hide={this.state.hide}
          onClose={() => {
            this.setState({ hide: !this.state.hide });
          }}
        >
          {this.state.document ? (
            this.state.document.base64 ? (
              <iframe
                title="dpf1"
                scrolling="no"
                width="100%"
                height="95%"
                src={this.state.document.base64}
              ></iframe>
            ) : (
              <iframe
                title="dpdf1"
                scrolling="no"
                width="100%"
                height="95%"
                src={
                  "https://docs.google.com/viewer?url=" +
                  this.state.document.url +
                  "&embedded=true"
                }
              ></iframe>
            )
          ) : null}
        </Modal>
        <Modal
          closeButtonStyle={{ color: "white" }}
          overlayStyle={{ background: "rgba(0, 0, 0, 0.4)" }}
          hide={this.state.hideChangeDate}
          onClose={() => {
            this.setState({
              hideChangeDate: !this.state.hideChangeDate,
              newDate: null,
            });
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              background: "rgba(0, 0, 0, 1);",
              height: "130px",
              width: "250px",
              padding: 12,
            }}
          >
            <div style={{ textAlign: "center", marginBottom: 2 }}>
              Vælg en ny dato
            </div>
            <Datepicker
              onChange={(e) => {
                this.setState({
                  newDate: e,
                });
              }}
              defaultValue={date}
            />
            <button
              style={{
                display: "inline-block",
                width: "100%",
                marginTop: "10px",
              }}
              className={
                this.state.newDate ? "btn btn-primary" : "btn btn-default"
              }
              onClick={() => {
                if (this.state.isSavingNewDate) {
                  return;
                }
                this.setState({
                  isSavingNewDate: true,
                });
                var _url =
                  process.env.REACT_APP_webApiEndPoint +
                  "api/dailyreport/changedate";
                httpPut(_url, {
                  date: this.state.newDate,
                  id: this.props.currentDailyReportId,
                })
                  .then((resp) => resp.json())
                  .then((id) => this.delay(7000, id))
                  .then((id) => {
                    this.setState({
                      isSavingNewDate: false,
                    });
                    return id;
                  })
                  .then((id) => {
                    dispatch(setDate(this.state.newDate, id));
                    return id;
                  })
                  .then((id) => {
                    this.setState({
                      hideChangeDate: !this.state.hideChangeDate,
                      newDate: null,
                    });
                    return id;
                  })
                  .then((id) => {
                    dispatch(attemptGetDailyReport(id));
                  })
                  .catch(() => {
                    alert("Kunne ikke ændre dato for dagrapport");
                  });
              }}
            >
              {this.state.isSavingNewDate ? (
                <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
              ) : (
                "Gem"
              )}
            </button>
          </div>
        </Modal>
        {this.state.isShowingDeleteModal ? (
          <ConfirmationModal
            closeModal={this.toggleIsShowingDeleteModal}
            onYesMethod={() =>
              dispatch(attemptDeleteDailyReport(params.workplaceId))
            }
            headerText="Dagrapport"
            text={
              <div>
                Du er ved at slette dagrapporten.
                <br />
                Vil du fortsætte?
              </div>
            }
          />
        ) : null}
        {this.state.isShowingEmailModal ? (
          <EmailModal
            closeModal={this.toggleIsShowingEmailModal}
            getEmailSuggestions={(val, alreadyChosen) =>
              dispatch(getEmailSuggestions(val, alreadyChosen))
            }
            emailSuggestions={emailSuggestions}
            showEmailConfirmation={this.props.showEmailConfirmation}
            onSend={(recipients) => {
              dispatch(attemptSendEmails(recipients, currentDailyReportId));
            }}
            isSending={isSending}
          />
        ) : null}
        <div style={styles.content}>
          <div className="col-xs-12" style={styles.contentContainer}>
            <div style={styles.dailyReportSwitchContainer}>
              {currentDailyReportId != null ? (
                <DailyReportSwitch
                  listOfDailyReports={listOfDailyReports}
                  onDailyReportChange={(id) => {
                    dispatch(attemptGetDailyReport(id));
                  }}
                  currentDailyReportId={currentDailyReportId}
                  canCreateNew={!isEditMode}
                  createNew={() =>
                    dispatch(
                      attemptCreateDailyReport(this.props.params.workplaceId)
                    )
                  }
                />
              ) : null}
            </div>
            <div style={styles.datepickerRow}>
              {!isEditMode || isLoading ? (
                <div>
                  <div
                    style={[
                      styles.timeRegistrationSwitch,
                      styles.timeRegistrationBilleder,
                      styles.inactiveTab,
                      styles.timeRegistrationSwitchIsEdit,
                    ]}
                  ></div>
                  <div
                    style={[
                      styles.timeRegistrationSwitch,
                      styles.timeRegistrationForbrug,
                      styles.inactiveTab,
                      styles.timeRegistrationSwitchIsEdit,
                    ]}
                  ></div>
                  <div
                    style={[
                      styles.timeRegistrationSwitch,
                      styles.inactiveTab,
                      styles.timeRegistrationSwitchIsEdit,
                    ]}
                  ></div>
                </div>
              ) : (
                <div>
                  <div
                    className="waves-btn wavesHover"
                    style={[
                      styles.timeRegistrationSwitch,
                      styles.timeRegistrationBilleder,
                      isShowingTimeRegistration === "images"
                        ? styles.activeTab
                        : styles.inactiveTab,
                    ]}
                    onClick={() =>
                      dispatch(setIsShowingTimeRegistration("images"))
                    }
                  >
                    Billeder
                  </div>
                  <div
                    className="waves-btn wavesHover"
                    style={[
                      styles.timeRegistrationSwitch,
                      styles.timeRegistrationForbrug,
                      isShowingTimeRegistration !== "images" &&
                      !isShowingTimeRegistration
                        ? styles.activeTab
                        : styles.inactiveTab,
                    ]}
                    onClick={() =>
                      dispatch(setIsShowingTimeRegistration(false))
                    }
                  >
                    Forbrug
                  </div>
                  <div
                    className="waves-btn wavesHover"
                    style={[
                      styles.timeRegistrationSwitch,
                      isShowingTimeRegistration !== "images" &&
                      isShowingTimeRegistration
                        ? styles.activeTab
                        : styles.inactiveTab,
                    ]}
                    onClick={() => dispatch(setIsShowingTimeRegistration(true))}
                  >
                    Timeregistrering
                  </div>
                </div>
              )}

              <div style={styles.datePickerContainer}>
                <DatepickerOnWeeks
                  defaultValue={date}
                  onChange={this.changeDate}
                />
              </div>
            </div>
            <div style={styles.underLine}></div>
            {isEditMode ? (
              <div style={styles.iconsRow}>
                <div
                  className="waves-btn wavesHover"
                  style={styles.iconsContainer}
                  ref="annuller"
                  onClick={this.onCancel}
                >
                  <i
                    className="fa fa-undo"
                    aria-hidden="true"
                    style={styles.icon}
                  ></i>
                  <div style={styles.label}>Annuller</div>
                </div>
                <div style={styles.divider}></div>
                <div
                  ref="Gem"
                  className="waves-btn wavesHover"
                  style={[styles.iconsContainer, styles.borderRight]}
                  onClick={() => {
                    if (!isSavingDailyReport)
                      dispatch(attemptSaveDayReport(params.workplaceId));
                  }}
                >
                  {isSavingDailyReport ? (
                    <i className="fa fa-spinner fa-spin" style={styles.icon} />
                  ) : (
                    <i
                      className="fa fa-floppy-o"
                      aria-hidden="true"
                      style={styles.icon}
                    ></i>
                  )}
                  <div style={styles.label}>
                    {isSavingDailyReport ? "Gemmer..." : "Gem"}
                  </div>
                </div>
              </div>
            ) : (
              <div style={styles.iconsRow}>
                {!signature && !approved ? (
                  <div style={{ float: "right" }}>
                    <div
                      ref="slet"
                      className="waves-btn wavesHover"
                      style={styles.iconsContainer}
                      onClick={this.toggleIsShowingDeleteModal}
                    >
                      <i
                        className="fa fa-trash-o"
                        aria-hidden="true"
                        style={styles.icon}
                      ></i>
                      <div style={styles.label}>Slet</div>
                    </div>
                    <div style={styles.divider}></div>
                  </div>
                ) : null}
                <div
                  ref="email"
                  className="waves-btn wavesHover"
                  style={styles.iconsContainer}
                  onClick={this.toggleIsShowingEmailModal}
                  // onClick={() => alert("ude af drift")}
                >
                  <i
                    className="fa fa-envelope-o"
                    aria-hidden="true"
                    style={styles.icon}
                  ></i>
                  <div style={styles.label}>Send email</div>
                </div>
                <div style={styles.divider}></div>
                <a
                  href={_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.printLink}
                >
                  <div
                    ref="print"
                    className="waves-btn wavesHover"
                    style={styles.iconsContainer}
                  >
                    <i
                      className="fa fa-print"
                      aria-hidden="true"
                      style={styles.icon}
                    ></i>
                    <div style={styles.label}>Print</div>
                  </div>
                </a>
                {
                  //only show signature label, if signature is not already there.
                  !signature ? (
                    <div>
                      {isEditSignature ? (
                        //if is in edit signature mode, put overlay on buttons, so they cant be clicked
                        <div>
                          <div style={styles.leftIconOverlay} />
                          <div style={styles.rightIconOverlay} />
                        </div>
                      ) : null}
                      <div style={styles.divider}></div>
                      <div
                        ref="underskriv"
                        className="waves-btn wavesHover"
                        style={[
                          styles.iconsContainer,
                          isEditSignature && styles.iconsContainerActive,
                        ]}
                        onClick={() =>
                          dispatch(dailyReportToggleEditSignature(true))
                        }
                      >
                        <i
                          className="fa fa-pencil-square-o"
                          aria-hidden="true"
                          style={styles.icon}
                        ></i>
                        <div style={styles.label}>Underskriv</div>
                      </div>
                      <div style={styles.divider}></div>

                      {
                        //if its not approved, you are allowed to edit the dailyReport
                        !approved ? (
                          <div>
                            <div style={styles.divider}></div>
                            <div
                              ref="rediger"
                              className="waves-btn wavesHover"
                              style={styles.iconsContainer}
                              onClick={() =>
                                dispatch(dailyReportToggleEdit(true))
                              }
                            >
                              <i
                                className="fa fa-pencil"
                                aria-hidden="true"
                                style={styles.icon}
                              ></i>
                              <div style={styles.label}>Rediger</div>
                            </div>
                          </div>
                        ) : null
                      }
                      <div
                        ref="skiftdato"
                        className="waves-btn wavesHover"
                        style={[
                          styles.iconsContainer,
                          isEditSignature && styles.iconsContainerActive,
                        ]}
                        onClick={() => {
                          this.setState({
                            hideChangeDate: !this.state.hideChangeDate,
                          });
                        }}
                      >
                        <i
                          className="fa fa-calendar"
                          aria-hidden="true"
                          style={styles.icon}
                        ></i>
                        <div style={styles.label}>Ændr Dato</div>
                      </div>
                    </div>
                  ) : null
                }
              </div>
            )}

            {isLoading ? (
              <PageSpinner style={{ color: semanticColors.text }} />
            ) : isEditMode ? (
              <div style={[styles.height100, styles.width100]}>
                <div
                  className="col-xs-3 text-center"
                  style={[styles.height100]}
                >
                  <EmployeeOverview
                    userAcks={userAcks}
                    employees={employees}
                    setEmployeeIsDragging={(bool) =>
                      dispatch(setEmployeeIsDragging(bool))
                    }
                    getTotalActivityHours={this.getTotalActivityHours}
                    employeeIsDragging={employeeIsDragging}
                    rmEmployeeFromProject={(employeeIndex) =>
                      dispatch(
                        rmEmployeeFromWorkplace(
                          employeeIndex,
                          params.workplaceId
                        )
                      )
                    }
                    getEmployeeSuggestions={(val) =>
                      dispatch(getEmployeeSuggestions(val))
                    }
                    employeeSuggestions={employeeSuggestions}
                    addEmployee={(val) =>
                      dispatch(attemptAddEmployee(val, params.workplaceId))
                    }
                    canDrag={
                      isShowingTimeRegistration === "images"
                        ? false
                        : isShowingTimeRegistration
                    }
                  />
                </div>
                <div className="col-xs-9" style={styles.rightSideContainer}>
                  {isShowingTimeRegistration === "images" ? (
                    <Imag params={{ workplaceId: params.workplaceId }} />
                  ) : isShowingTimeRegistration ? (
                    <Employees userAcks={userAcks} />
                  ) : (
                    <DailyReportContainer
                      workplaceId={this.props.params.workplaceId}
                    />
                  )}
                </div>
              </div>
            ) : (
              <StaticDailyReport
                workplaceId={params.workplaceId}
                openPdf={this.openPdf}
              />
            )}
          </div>
          {/*CONTENT END*/}
        </div>
      </div>
    );
  }
}

var styles = {
  content: {
    height: "100%",
  },
  innerContainer: {
    height: "100%",
    backgroundColor: semanticColors.default,
  },
  contentContainer: {
    height: "100%",
    padding: "150px 0px 10px 0px",
    position: "relative",
  },
  height100: {
    height: "100%",
  },
  width100: {
    width: "100%",
  },
  printLink: {
    color: semanticColors.text,
  },
  rightSideContainer: {
    height: "100%",
    padding: "0",
  },
  datepickerRow: {
    width: "100%",
    height: "42px",
    position: "absolute",
    top: "10px",
  },
  timeRegistrationSwitch: {
    position: "absolute",
    right: "320px",
    width: "150px",
    top: "11px",
    height: "40px",
    lineHeight: "40px",
    borderTopLeftRadius: "2px",
    borderTopRightRadius: "2px",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    zIndex: "1",
    padding: "0px",
    borderBottomLeftRadius: "0px",
    borderBottomRightRadius: "0px",
  },
  timeRegistrationSwitchIsEdit: {
    top: "38px",
    height: "12px",
  },
  timeRegistrationForbrug: {
    right: "166px",
  },
  timeRegistrationBilleder: {
    right: "12px",
  },
  datePickerContainer: {
    float: "left",
  },
  iconsRow: {
    width: "50%",
    position: "absolute",
    top: "69px",
    right: "12px",
  },
  iconsContainer: {
    textAlign: "center",
    float: "right",
    width: "80px",
    height: "50px",
    padding: "5px",
  },
  iconsContainerActive: {
    color: semanticColors.info,
  },
  label: {
    fontSize: "12px",
    marginTop: "4px",
    fontWeight: "600",
  },
  icon: {
    display: "block",
    fontSize: "22px",
  },
  activeTab: {
    color: semanticColors.info,
    borderLeft: "1px solid" + semanticColors.mainBackground,
    borderTop: "1px solid" + semanticColors.mainBackground,
    borderRight: "1px solid" + semanticColors.mainBackground,
    borderBottom: "1px solid" + semanticColors.default,
  },
  inactiveTab: {
    top: "15px",
    border: "none",
    height: "35px",
    lineHeight: "35px",
    zIndex: "0px",
    color: "#fff",
    backgroundColor: semanticColors.mainBackground,
  },
  underLine: {
    position: "absolute",
    left: "0",
    right: "0",
    top: "60px",
    height: "1px",
    backgroundColor: semanticColors.mainBackground,
  },
  divider: {
    display: "inline-block",
    float: "right",
    width: "1px",
    height: "30px",
    marginTop: "10px",
    backgroundColor: semanticColors.mainBackground,
  },
  leftIconOverlay: {
    position: "absolute",
    right: "320px",
    width: "166px",
    height: "50px",
    backgroundColor: semanticColors.default,
    opacity: "0.5",
    zIndex: "2",
  },
  rightIconOverlay: {
    position: "absolute",
    right: "0px",
    width: "245px",
    height: "50px",
    backgroundColor: semanticColors.default,
    opacity: "0.5",
    zIndex: "2",
  },
  dailyReportSwitchContainer: {
    position: "absolute",
    top: "75px",
    width: "50%",
  },
  emailConfimation: {
    width: "500px",
    height: "500px",
    color: "#fff",
    backgroundColor: "red",
  },
};

const selectProps = (state) => {
  return {
    ...state.dailyReportReducer,
    employees: state.dailyReportEmployeesReducer.employees,
    activities: state.dailyReportActivitiesReducer.activities,
    signature: state.dailyReportSignatureReducer.signature,
    userAck: state.workplaceOverviewReducer.userAck,
  };
};

export default connect(selectProps)(Radium(DailyReport));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/index.jsx